export default __webpack_public_path__ + "static/media/sword_of_descension.eb67a1df.png";